import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wrt3xtnbxw: FaireBrandEntity = {
  token: "b_wrt3xtnbxw",
  type: "brand",
  name: "Aria Romance",
  avatarUrl:
    "https://cdn.faire.com/fastly/ddec3a673724e3b703d65f72c1f7f9903435e9173fb527cc8cf6c4a41a5114e1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b1700d85d6c68d599b902bc7a3bd86654b6ce06b85dc4d5600706b489911449c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ddec3a673724e3b703d65f72c1f7f9903435e9173fb527cc8cf6c4a41a5114e1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b1700d85d6c68d599b902bc7a3bd86654b6ce06b85dc4d5600706b489911449c.jpeg",
  location: "Los Angles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.3,
  reviewCount: 118,
  isInsider: true,
  description:
    '"ALL DUTY AND TAX ARE COVERED BY US."\n\nAll will be shipped out within 24 hours! All of our items are ready for immediate shipping!!\n\nOpen Pack, No Minimum Order Quantities (MOQs)\n\nWe can search for the product you need. Simply send us a message, and we will take care of the rest!\n\nEstablished in 1996, we have maintained a strong presence in various locations, including the USA, Canada, Mexico, South America, and Europe. Our company\'s solid reputation and success can be attributed to our unwavering commitment to exceeding customer expectations in terms of quality, design, and affordability. \n\nWith 27 years of industry experience, we ensure the best quality and affordable prices for our customers. Our main mission is to consistently provide premium yet affordable clothing for a variety of styles. We are both a wholesaler and a manufacturer, which enables us to maintain top-notch quality while ensuring affordable prices. You can find our complete Fashion Catalog, which includes everything that the Fashion District has to offer. From chic dresses to stylish tops, we have everything you need to keep your customers coming back for more.\n',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:40.497Z",
    importedBy: "entity-db-cli",
  },
};
